import { render, staticRenderFns } from "./contragents-row.vue?vue&type=template&id=84890888"
import script from "./contragents-row.vue?vue&type=script&lang=js"
export * from "./contragents-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports